import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useAgyleConfigStyles} from '../agyle_configuration';
import {externalConfigs, saveExternalConfigs} from '../../../store/reducers/externalConfig';
import * as React from 'react';
import {useEffect, useState} from 'react';
import _ from 'lodash';
import {Divider, Paper} from '@mui/material';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import {DEFAULT_OBS_CFG_VALUE} from './configDefaultValues';

const ObsCfg = ({context}) => {
    const classes = useAgyleConfigStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    // Config state
    const cfgs = useSelector(externalConfigs);
    const [obsState, setObsState] = useState(DEFAULT_OBS_CFG_VALUE);
    const [externalConfig, setExternalConfig] = useState(null);

    useEffect(() => {
        const find = _.find(cfgs, cfg => cfg.configType === context?.id);
        if (find) {
            setObsState(prevState => ({
                ...prevState,
                ...find?.value,
            }));
            setExternalConfig(find);
        }
    }, [cfgs]);

    const handleSaveConfig = () => {
        let value = _.cloneDeep(obsState);
        const objToSave = {
            __id: externalConfig?.__id || null,
            description: context.description,
            configType: context.id,
            active: true,
            value,
        };
        dispatch(saveExternalConfigs(objToSave));
    };

    const handleSwitchChange = (value, name) => {
        setObsState(prevState => ({...prevState, [name]: value}));
    };

    const handleResetToDefault = () => {
        setObsState(DEFAULT_OBS_CFG_VALUE);
    };

    return (
        <>
            <Paper className={classes.paper} style={{marginTop: 10}}>
                <FormLabel className={classes.label}>
                    {t(context?.description)}
                </FormLabel>

                <Divider style={{margin: 10}}/>

                <Typography variant="subtitle2" sx={{marginBottom: '10px'}}>
                    {t('Activate options for the observation form.')}
                </Typography>

                <div className={classes.divRow}>
                    <AgyleBlockSwitch
                        onChange={(val) => handleSwitchChange(val, 'retrospective')}
                        value={obsState?.retrospective}
                        style={{marginRight: 10}}
                    />

                    <FormLabel>
                        {t('Retrospective observations?')}
                    </FormLabel>
                </div>

                <div className={classes.action}>
                    <AgyleButton
                        onClick={handleResetToDefault}
                        variant="contained"
                    >
                        {t('Reset to default')}
                    </AgyleButton>

                    <AgyleButton
                        onClick={handleSaveConfig}
                        variant="contained"
                    >
                        {t('Save changes')}
                    </AgyleButton>
                </div>
            </Paper>
        </>
    );
};

export default ObsCfg;